module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_dx-814dd6c6fe523c56b2a9ce80242aee51.svg";